import { datadogRum } from '@datadog/browser-rum';

import { DATADOG_ENABLED, DATADOG_ENV } from '../../env';

export const initializeDataDogRUM = (): void => {
  if (!DATADOG_ENABLED) {
    return;
  }

  datadogRum.init({
    applicationId: '670e3679-ab8c-4268-91ef-589776699efd',
    clientToken: 'puba20ff77dc63ddf80a352b2f92624e706',
    site: 'datadoghq.com',
    service: 'qualifications',
    env: DATADOG_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [`https://${window.location.hostname}`],
    sessionPersistence: 'local-storage',
  });
  datadogRum.startSessionReplayRecording();
};
